import React, { useRef, useState } from 'react';
import { useLocation } from "@reach/router"

import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'

import CaseInfoCard from './CaseInfoCard';
import makeFilters from '../../../app/common/RegexFilters';
import Spacer from '../../../app/common/ui/Spacer';

const CaseInfoContent = ({ member, cases, onChange }) => {
    const location = useLocation();
    const search = (new URLSearchParams(location.search)).get('filter') || '';
    const [query, setQuery] = useState(makeFilters(search));
    const filterRef = useRef();

    const handleFilterChange = () => {
        setQuery(makeFilters(filterRef.current?.value));
    }

    return (
        <div>
            <Alert severity="info" variant="filled">This page brings all your individual referrals, quotes, bookings etc. together based on the court case number. If the court case number was not provided by the referrer it will show as 00000000 and you can click on the pen icon by the case number to make changes. You can click on the coloured buttons by the case work to go to the full page. This is a new page so any feedback would be very welcome!</Alert>
            <Spacer space="0.5rem" />
            <Typography variant="h6" color="initial">{member?.name} Cases</Typography>
            <Spacer space="0.5rem" />
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        onChange={handleFilterChange}
                        inputRef={filterRef}
                        defaultValue={search}
                        label="Search your cases"
                        fullWidth
                    />
                </Grid>
                <Grid item container direction="column" xs={12}>
                    {
                        cases?.filter(item => query.every(q => q.test(JSON.stringify(item))))
                            .map(item => {
                                return <Grid item key={item.id}>
                                    <CaseInfoCard caseInfo={item} onChange={onChange} />
                                </Grid>

                            })
                    }
                </Grid>
            </Grid>
        </div>
    );
};

export default CaseInfoContent;